import * as Yup from 'yup';

const addOnProductSchema = Yup.object().shape({
  labelEn: Yup.string().required('English Label is required.'),
  labelAr: Yup.string().required('Arabic Label is required.'),
  previewUrl: Yup.string().required('Preview URL is required.'),
  position: Yup.number()
    .min(1, "Please enter more than 1")
    .typeError("Must be Number"),
  // stock: Yup.number()
  //   .required("Stock is required.")
  //   .typeError("Must be Number"),
  price: Yup.number()
    .required("Price is required.")
    .typeError("Must be Number"),
});

export default addOnProductSchema;